export default {
  brand: 'qrka',
  domain: 'qrka.ru',
  title: 'qrka.ru - бесплатный генератор QR-кодов',
  description:
    'Бесплатный локальный генератор статических QR-кодов для ссылок, текста, Wi-Fi и контактов. PNG и SVG без регистрации, watermark и pro-ограничений.',
  metrikaId: '110207924',
  ogImage: 'https://qrka.ru/og-image.png',
}
